import axios from 'axios';
import { toast } from 'react-toastify';

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  error => {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      'Your session has expired. Please log in again.';
    const errorCode = error?.response?.data?.errorCode;

    if (errorCode === 1450 || errorCode === 1451) {
      localStorage.setItem('session_message', message);
      localStorage.clear();
      toast.warning(message);
      localStorage.setItem('session_message', message);
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default api;
